import { getSiteDetails } from '@atlassian/mpac-api-client';
import { StargateAPI } from '@atlassian/mpac-services-client';
import { hooks } from '@atlassian/mpac-utils';
export const useAvailableSites = (stargateBaseUrl, products) => {
  const availableSitesPromise = () => new StargateAPI(stargateBaseUrl).marketplace.availableSites(products);
  const {
    result,
    error,
    pending
  } = hooks.usePromise(availableSitesPromise, [products, stargateBaseUrl]);
  return {
    availableSitesPending: pending,
    availableSitesError: error,
    availableSitesResult: result === null || result === void 0 ? void 0 : result.sites
  };
};
export const useSelectedSiteDetails = (mpacBaseUrl, selectedSiteCloudId) => {
  const selectedSiteDetailsPromise = () => getSiteDetails(mpacBaseUrl, selectedSiteCloudId);
  const {
    result,
    error,
    pending
  } = hooks.usePromise(selectedSiteDetailsPromise, [mpacBaseUrl, selectedSiteCloudId]);
  return {
    selectedSiteDetailsPending: pending,
    selectedSiteDetailsError: error,
    selectedSiteDetailsResult: result
  };
};
export const useAppInstallPermission = (stargateBaseUrl, product, cloudId) => {
  const appInstallPermissionPromise = product && cloudId ? new StargateAPI(stargateBaseUrl).marketplace.appInstallPermission(product, cloudId) : new Promise(() => {});
  const {
    result,
    error,
    pending
  } = hooks.usePromise(() => appInstallPermissionPromise, [product, cloudId], !!(product && cloudId));
  return {
    appInstallPermissionPending: pending,
    appInstallPermissionError: error,
    appInstallPermissionResult: result
  };
};